import * as React from "react";
import { useContext } from "react";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@progress/kendo-react-buttons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InputChangeEvent } from "@progress/kendo-react-inputs/dist/npm/input/interfaces/InputChangeEvent";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { StyledButton } from "../../../../../Layout/Inputs/StyledButton";
import StyledPageMenuIcon from "../../../../../Layout/PageMenu/PageMenuIcon";
import { EditProjectContext } from "../../../EditProjectContext";
import TextInput from "../../../../../Layout/Inputs/TextInput";
import { StyledFlexAlignEnd } from "./FtlRouteHeader";
import { duplicateRoute } from "./DuplicateRoute";

type Props = {
  route: FtlRouteViewModel;
};

function DuplicateButton({ route }: Props) {
  const { project, reloadData } = useContext(EditProjectContext);

  const [showDuplicateRouteInput, setShowDuplicateRouteInput] = React.useState(false);

  const handleRouteNumberChange = (event: InputChangeEvent) => {
    setRouteNumber(event.target.value as string);
  };

  const [routeNumber, setRouteNumber] = React.useState("");

  async function onDuplicateButtonClick() {
    await duplicateRoute(project.ProjectId, route.RouteId, routeNumber);
    setShowDuplicateRouteInput(false);
    setRouteNumber("");
    reloadData();
  }

  return !showDuplicateRouteInput ? (
    <StyledButton
      onClick={() => {
        setShowDuplicateRouteInput(!showDuplicateRouteInput);
      }}
      width="100%"
    >
      <StyledPageMenuIcon icon={faCopy} /> Duplicate
    </StyledButton>
  ) : (
    <StyledFlexAlignEnd>
      <TextInput
        label="Route Number"
        onChange={handleRouteNumberChange}
        name="routeNumber"
        value={routeNumber}
        onBlur={() => setShowDuplicateRouteInput(false)}
      />

      <Button disabled={routeNumber.length === 0} onMouseDown={() => onDuplicateButtonClick()}>
        <FontAwesomeIcon icon={faCopy} />
      </Button>
    </StyledFlexAlignEnd>
  );
}

export default DuplicateButton;
